module.exports = __webpack_public_path__ + "static/media/GYM Content (1).a869de49.png";